// extracted by mini-css-extract-plugin
export default {"wrapper":"L2-z","play":"M2-z"};